export default "__VITE_ASSET__4b1cd76c__"